import Network from './network';

export default {
  getPaidCoffeeCostAndQuantity(args) {
    this.getCostAndQuantity('/payment/paid_coffee_cost_and_quantity', args);
  },

  getPremiumCostAndQuantity(args) {
    this.getCostAndQuantity('/payment/premium_cost_and_quantity', args);
  },

  getCostAndQuantity(basePath, args) {
    const urlParams = [];
    if (args.useCache) urlParams.push(`use_cache=${args.useCache}`);
    const url = `${basePath}?${urlParams.join('&')}`;
    Network.get(url, args);
  },
};
